<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-vendor-detail class="flex" [vendor]="vendor" (close)="onClose($event)"> </app-vendor-detail>
</div>
